import type { LocaleCode } from '../i18n/types.ts'

const LANG_KEY = 'zion_lang'
const LANG_CHOSEN_KEY = 'zion_lang_chosen'

/** Stesse lingue del sito / app Android ZION. */
export const SUPPORTED_LOCALES: { code: LocaleCode; label: string }[] = [
  { code: 'it', label: 'Italiano' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'ru', label: 'Русский' },
  { code: 'ja', label: '日本語' },
  { code: 'ar', label: 'العربية' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'sv', label: 'Svenska' },
  { code: 'nb', label: 'Norsk' },
  { code: 'da', label: 'Dansk' },
  { code: 'fi', label: 'Suomi' },
  { code: 'pl', label: 'Polski' },
]

const VALID = new Set(SUPPORTED_LOCALES.map((l) => l.code))

export function getStoredLocale(): LocaleCode | null {
  try {
    const v = localStorage.getItem(LANG_KEY)
    if (v && VALID.has(v as LocaleCode)) return v as LocaleCode
  } catch {
    /* ignore */
  }
  return null
}

export function resolveLocale(): LocaleCode {
  const stored = getStoredLocale()
  if (stored) return stored
  const nav = (navigator.language || 'en').toLowerCase()
  const primary = nav.slice(0, 2)
  // nb-NO / nn-NO → nb
  if (nav.startsWith('nb') || nav.startsWith('nn') || nav === 'no') return 'nb'
  if (VALID.has(primary as LocaleCode)) return primary as LocaleCode
  return 'en'
}

export function saveLocale(code: LocaleCode): void {
  localStorage.setItem(LANG_KEY, code)
  localStorage.setItem(LANG_CHOSEN_KEY, '1')
}

export function isLanguageChosen(): boolean {
  try {
    return localStorage.getItem(LANG_CHOSEN_KEY) === '1'
  } catch {
    return false
  }
}
